import { SaveableSettingsProvider } from "../saveable-settings-provider";

export class ViewObjectContainerSaveableSettingsProvider extends SaveableSettingsProvider {
  constructor(viewObjectProviders) {
    super();
    this.viewObjectProviders = viewObjectProviders; // type: Map
  }

  createItemSettings(itemSetings) {
    if (itemSetings === undefined) {
      return {};
    }
    const objProvider = this.viewObjectProviders.get(itemSetings.type);
    if (objProvider === undefined) {
      return undefined;
    }
    return objProvider.createSaveableSettings(itemSetings);
  }

  applyItemSettings(itemSetings, saveableItemSettings) {
    if (itemSetings === undefined) {
      return;
    }
    const objProvider = this.viewObjectProviders.get(itemSetings.type);
    if (objProvider === undefined) {
      return undefined;
    }
    objProvider.applySaveableSettings(itemSetings, saveableItemSettings);
  }
}
